import { render, staticRenderFns } from "./FinalizarCompra.vue?vue&type=template&id=320906f8&scoped=true&"
import script from "./FinalizarCompra.vue?vue&type=script&lang=js&"
export * from "./FinalizarCompra.vue?vue&type=script&lang=js&"
import style0 from "./FinalizarCompra.vue?vue&type=style&index=0&id=320906f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320906f8",
  null
  
)

export default component.exports